import Button from 'components/Button';
import Icon from 'components/Icon';

const CancelButton = props => (
  <Button theme="square" style={{ background: '#a2a3a9' }} {...props} children={<Icon type="times" />} />
);

export default CancelButton;
